import { Formik, Form, ErrorMessage } from 'formik';
import React, {useEffect, useState } from 'react';
import styles from "./account.module.scss"
import { otpVerificationSchema } from '../../validationSchemas/otpVeficationSchema';
import Button from '../../components/Buttons/Button';
import OTPInput from 'react-otp-input';
import { parseISO, differenceInSeconds} from 'date-fns';
import Big from 'big.js';
interface OtpVerificationFormProps {
    handleOtpVerification: (values, setSubmitting) => void;
    resendOtp: (setSubmitting) => void;
    userEmail: string;
    otpExpiry
}

const OtpVerificationForm: React.FunctionComponent<OtpVerificationFormProps> = ({
    handleOtpVerification,
    resendOtp,
    userEmail,
    otpExpiry
}) => {
    const initialValues = {
        otp: "",
    }
    const [timeLeftInSec, setTimeLeftInSec] = useState<number>(60);
    const setCounter = () => {
        const expiryDate = parseISO(otpExpiry);
        const now = new Date();
        const diffSec = differenceInSeconds(expiryDate, now);
        setTimeLeftInSec(diffSec);
    }
    const getCounter = () => {
        const total = new Big(timeLeftInSec);
        const minutes = total.div(60).round(0, 0);
        const seconds = total.mod(60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    }
    useEffect(() => {
        setCounter();
    }, [otpExpiry]);
    const [disableResetButton, setDisableResetButton] = useState<boolean>(true);
    const [disableAllButtons, setDisableAllButtons] = useState<boolean>(false);

    const handleResendOtpButton = async () => {
        await resendOtp(setDisableAllButtons);
        setDisableResetButton(true);
    }

    const handleFormSubmission = async (values) => {
        await handleOtpVerification(values, setDisableAllButtons);
    }
    
    const maskEmail = (email: string): string => {
        const [localPart, domain] = email.split('@');
        if (localPart.length <= 2) {
            return `${localPart[0]}***@${domain}`;
        }
        return `${localPart[0]}${'*'.repeat(localPart.length - 2)}${localPart.slice(
            -1,
        )}@${domain}`;
    };

    useEffect(() => {
        if (timeLeftInSec === 0) {
            setDisableResetButton(false);
            return;
        }

        const timer = setTimeout(() => {
            setTimeLeftInSec(timeLeftInSec - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [timeLeftInSec]);


    return (
        <>
            <Formik
                onSubmit={handleFormSubmission}
                initialValues={initialValues}
                validationSchema={otpVerificationSchema}
            >
                {({
                    setFieldValue,
                    values
                }) => (
                    <Form data-testid="otp-container">
                        <OTPInput
                            value={values.otp}
                            onChange={(otp) => setFieldValue('otp', otp)}
                            numInputs={6}
                            renderSeparator={<span>-</span>}
                            containerStyle={styles.otpInputField}
                            inputType='tel'
                            inputStyle={styles.otpInputBox}
                            renderInput={(props) => <input {...props} data-testid="otp-inputs"  />}
                        />
                        <div className={`clr-dark-red f-s16 font-rale ${styles.otpErrorMessage}`}>
                            <ErrorMessage name="otp" />
                        </div>
                        <hr className="my-4 " />
                        <div className="max-content mx-auto">
                            <Button
                                type="submit"
                                className="d-block mb-3"
                                disabled={!disableResetButton || disableAllButtons}
                            >
                                Verify
                            </Button>
                            <Button
                                type="button"
                                className={`clr-dark-grey d-block f-s16 font-Visby-cf f-w8 text-center underline ${styles.resendButton}`}
                                disabled={disableResetButton || disableAllButtons}
                                onClick={() => {
                                    setFieldValue('otp', "");
                                    handleResendOtpButton();
                                }}
                            >
                                {
                                    timeLeftInSec > 0 ?
                                        `Resend code in ${getCounter()}` :
                                        'Resend'
                                }
                                
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default OtpVerificationForm;
